import * as React from 'react';

import { Link } from 'react-resource-router';
import styled from 'styled-components';

import { BannerAnnouncement } from './Banner';
import { Container } from './Container';
import cookiesHistory from '../assets/cookies-history.jpeg';
import marcaroon from '../assets/macaroons.jpeg';
import '../css/about.css';

const Wrapper = styled.div`
  border: 1px solid #333;
  padding: 20px;
  background: rgb(0, 0, 40, 3%);
`;

export const About = (): JSX.Element => {
  return (
    <Container>
      <BannerAnnouncement />
      <br />
      <Wrapper>
        <h2>Cookies: An Origin Story</h2>
        <div className="banner">
          <img src={cookiesHistory} alt="History" />
        </div>
        <p className="content">
          A little about the where cookies came from and how they came to be…
          But first -- before we get into the origin of cookies -- what exactly
          are cookies?
        </p>
        <p className="content">
          Today’s cookie story is brought to you by Jane, who said this is what
          she’d like to learn about. If you guys didn’t know, I take requests. I
          don’t always fill them immediately, but I often write about foods or
          ingredients I was asked to teach about in here. In this particular
          case, I asked Jane what she wanted to know about. Thanks, Jane, for
          our tour of cookies and biscuits today!
        </p>
        <p className="content">
          Before we really get into the nuts and bolts of cookies, let’s talk
          about what cookies are. No one seems really clear about that, and
          ditto which word should be used for them. Cookies are small, thin
          cakes. They are generally also sweet, but I have baked cookies that
          outraged eaters told me were not cookies because they weren’t sweet.
          These were still cookies. Just not standard American ones.
        </p>
        <div className="banner">
          <img src={marcaroon} alt="Marcaroon apparently" />
        </div>
        <p className="content">
          There’s a reason I’m still talking about macarons and macaroons. Even
          though many of people seem to pronounce these the same way and think
          they’re the same thing, this is not the case. I assume these get
          confused because they’re made similarly and both are gluten-free, but
          they really are fairly different
        </p>
        <br />
        <Link to="/">Back To Home</Link>
      </Wrapper>
    </Container>
  );
};
